// extracted by mini-css-extract-plugin
export default {"onlineIconImg":"XwuwNg_ik03YRETarHai","input":"UJg68HPdYYmQDcDmnTdJ"};